import React, { FC } from 'react'

type Props = {
  text: string
}

export const CaptionOverlay: FC<Props> = ({ text }) => {
  if (!text) return null

  return (
    <div
      data-testid='legenda-ao-vivo'
      className='position-absolute bottom-0 mb-15 w-100 px-10 text-center pe-none z-index-3'
    >
      <span className='bg-white bg-opacity-75 text-black py-2 px-4 rounded fs-5 d-inline-block fw-bold'>
        {text}
      </span>
    </div>
  )
}
